// extracted by mini-css-extract-plugin
export var container = "_iv-0";
export var content = "_iv-3";
export var customerTitle = "_iv-4";
export var empty = "_iv-5";
export var gray = "_iv-6";
export var header = "_iv-7";
export var info = "_iv-8";
export var loading = "_iv-2";
export var loadingCard = "_iv-9";
export var oneLine = "_iv-a";
export var personName = "_iv-e";
export var pillContainer = "_iv-b";
export var selected = "_iv-1";
export var text = "_iv-c";
export var twoLines = "_iv-d";
export var unread = "_iv-f";
export var unreadIndicator = "_iv-g";